/*
*
* File JS per la Basic Page
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockTitle from 'components/block-title/block-title';
import heroSection from 'components/heroes/hero-section';
import mosaicoCards from 'components/mosaico-cards/mosaico-cards';
import blockText from 'components/block-text/block-text';
import blockService from 'components/block-service/block-service';
import blockCol2 from 'components/block-col2/block-col2';
import blockTabService from 'components/block-tab-service/block-tab-service';
import blockTabList from 'components/block-tab-list/block-tab-list';
import blockQuote from 'components/block-quote/block-quote';
import blockMasonryGallery from 'components/block-masonry-gallery/block-masonry-gallery';
import listNews from 'components/news/list-news';
import cardNews from 'components/news/card-news';
import blockSliderCards from 'components/block-slider-cards/block-slider-cards'; 

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './basic-page.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
    blockCol2();
    blockTabService();
    blockTabList();
    blockSliderCards();
});

//--------------------------------------------------------------------//